export const outerContainerId = "menu-outer-container";
export const pageWrapId = "menu-page-wrap";
